import React, {useEffect, useReducer} from 'react';
import PropTypes from "prop-types";
import {useSelector, useDispatch} from "react-redux";
import Drawer from "@mui/material/Drawer";
import {closeDrawer} from '../../actions/drawerActions';

const MainDrawer = () => {
    const dispatch = useDispatch();
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    
    const open = useSelector(state => state.openCloseSecondaryDrawer.open);
    const view = useSelector(state => state.openCloseSecondaryDrawer.view);
    const props = useSelector(state => state.openCloseSecondaryDrawer.props);

    useEffect(() => {
        const handleResize = () => {
            forceUpdate();
        };

        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    if (!view) {
        return null;
    }

    let viewComponent = view ? React.cloneElement(view, {closeDrawer: handleCloseDrawer}) : null;

    return (
        <Drawer
            open={open}
            anchor={props.anchor}
            docked={props.docked}
            opensecondary={props.opensecondary}
            PaperProps={{
                sx: { width: props.width },
            }}
        >
            {viewComponent}
        </Drawer>
    );
};

MainDrawer.propTypes = {
    closeDrawer: PropTypes.func,
    open: PropTypes.bool,
    view: PropTypes.node,
    props: PropTypes.object
};

export default MainDrawer;
